import { ScopeItem } from "../../scopeTypes.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const UPSERT_SCOPE_ITEM = createAppSessionEventDefinition({
  type: "UPSERT_SCOPE_ITEM",
  logSafe: {
    name: false,
    displayValue: false,
    type: true,
    rawType: false,
    isHidden: true,
    dataFrameSchema: false,
  },
  create: (payload: ScopeItem) => payload,
  apply: (previousState, payload) => {
    const warnings: string[] = [];

    const previousScopeItem = previousState.scopeItems[payload.name];

    if (previousScopeItem != null) {
      previousScopeItem.name = payload.name;
      previousScopeItem.displayValue = payload.displayValue;
      previousScopeItem.type = payload.type;
      previousScopeItem.rawType = payload.rawType;
      previousScopeItem.isHidden = payload.isHidden;
      previousScopeItem.dataFrameSchema = payload.dataFrameSchema;
    } else {
      previousState.scopeItems[payload.name] = payload;
    }

    return { warnings };
  },
});
